// extracted by mini-css-extract-plugin
export default {"overflow":"Burger_overflow__zxB1s","content":"Burger_content__25NOy"};